module.exports = __webpack_public_path__ + "static/media/manipal_logo.096c9768.png";